import styledComp from 'styled-components';
import VaultButton from '../../../../Shared/VaultButton';
import { Colors, Styling } from '../../../../../constants';

export const OperationsContainer = styledComp.div`
  position: sticky;
  top: 0;
  z-index: 1;
  height: 55px;
  padding: 6px 12px 6px 12px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  background-color: ${Colors.PAPER};
  border-bottom: 1px solid ${Colors.PAPER_DARKER_1};
  button svg {
    font-size: 1.5rem;
  }
`;

export const Button = styledComp(VaultButton)`
  margin-right: ${Styling.DEFAULT_SPACING}px;
  height: 42px;
`;

export const AnchoredButton = styledComp(VaultButton)`
  height: 42px;
`;

export const AnchoredGroup = styledComp.div`
  position: absolute;
  right: ${Styling.DEFAULT_SPACING}px;
  display: flex;
  gap: ${Styling.DEFAULT_SPACING}px;
`;
